import { StyleSheet } from 'aphrodite';
import { brandPrimary } from '../../styles/colors';

export const styleSheet = StyleSheet.create({
	clickableButton: {
		background: 'none',
		border: 'none',
		padding: 0,
		margin: 0,
		color: 'inherit',
		font: 'inherit',
		cursor: 'pointer',
		textAlign: 'inherit',
		lineHeight: 'inherit',
		textDecoration: 'underline',
		textDecorationColor: 'transparent',
		transition: 'text-decoration-color 0.2s ease',

		':hover': {
			color: brandPrimary,
			textDecorationColor: brandPrimary,
		},

		':focus': {
			outline: `2px solid ${brandPrimary}`,
			outlineOffset: 2,
		},
	},
});
